import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone, Mail } from "lucide-react";
import { COMPANY } from "../data/site";
import { useLang } from "../context/LangContext";

const LegalPage = ({ content }) => {
  const { S } = useLang();

  useEffect(() => {
    document.title = `${content.title} — GPN Sàrl`;
    window.scrollTo(0, 0);
    return () => {
      document.title = S.meta.title;
    };
  }, [content.title, S.meta.title]);

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-[#0A182E] border-b border-white/10">
        <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between">
          <Link to="/" data-testid="legal-logo-link" className="inline-flex items-center gap-3">
            <img src="/logo-emblem-dark.png" alt="GPN Sàrl" className="h-10 w-auto" />
            <span className="font-display font-bold text-white text-lg tracking-tight">GPN Sàrl</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-link"
            className="inline-flex items-center gap-2 text-sm font-medium text-slate-300 hover:text-sky-400 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" /> {S.legal.back}
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 py-16">
        <p className="font-tech text-xs font-semibold uppercase tracking-[0.28em] text-sky-600">GPN Sàrl</p>
        <h1 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">{content.title}</h1>
        <div className="mt-10 space-y-10">
          {content.sections.map((s) => (
            <section key={s.h}>
              <h2 className="font-display text-lg font-semibold text-slate-900">{s.h}</h2>
              <p className="mt-2 text-sm sm:text-base leading-relaxed text-slate-600">{s.p}</p>
            </section>
          ))}
        </div>

        <div className="mt-14 rounded-2xl border border-slate-200 bg-white p-6 flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-slate-600">
          <span className="font-semibold text-slate-900">{S.legal.contactLabel}</span>
          {COMPANY.phones.map((p) => (
            <a key={p.href} href={p.href} className="inline-flex items-center gap-2 hover:text-sky-600 transition-colors">
              <Phone className="w-4 h-4 text-sky-600" /> {p.label}
            </a>
          ))}
          <a href={`mailto:${COMPANY.email}`} className="inline-flex items-center gap-2 hover:text-sky-600 transition-colors">
            <Mail className="w-4 h-4 text-sky-600" /> {COMPANY.email}
          </a>
        </div>
      </main>
    </div>
  );
};

export const MentionsLegales = () => {
  const { S } = useLang();
  return <LegalPage content={S.legal.mentions} />;
};

export const PolitiqueConfidentialite = () => {
  const { S } = useLang();
  return <LegalPage content={S.legal.privacy} />;
};
